import { css as t } from "styled-components";
const f = ({ theme: o }) => /* @__PURE__ */ t([
  "body{font-family:",
  ";}"
], o.fonts.body);
export {
  f as default
};
